import {Component, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-page-builder-layout',
  templateUrl: './page-builder.component.html',
  styleUrls: ['./page-builder.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PageBuilderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
